/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/sahraparty/"

const sahraparty: CommunityData = {
  code: "sahraparty",
  inviteCode: "sahraparty",
  name: "Sahra Party",
  thumbnail: "",
  favicon: "",
  waitlist: true,
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/sah-963`,
  socials: {},
  styles: {
    comingSoon: {
      bgColor: "#e7348e",
      hero: {
        desktop: `https://media.werz.at/community-assets/sahraparty/mobile-landing-background.mp4?type=video`,
        mobile: `https://media.werz.at/community-assets/sahraparty/mobile-landing-background.mp4?type=video`,
        style: "bg-[#C8C8C8]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-alternative-logo.png`,
        mobile: `${S3_PREFIX}web-alternative-logo.png`,
        style: "w-[98px] h-[59px] sm:w-[152px] sm:h-[92px]",
      },
      werzLogoColor: "#191818",
      title: "font-['UltraRegular'] text-[28px] leading-[120%] text-[#0d0d0d]",
      text: "font-['WorkSansRegular'] text-[16px] leading-[120%] text-[#0d0d0d]",
      button:
        "font-['TerminaTestDemi'] text-[16px] leading-[120%] p-4 bg-[#ffffff] text-[#0d0d0d] cursor-pointer w-fit uppercase",
      input: {
        base: "font-['WorkSansRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-white text-[#0d0d0d]",
        border: "#D4D4D4",
        borderFocus: "#000000",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['WorkSansRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['WorkSansRegular'] text-[14px] leading-[120%] text-[#0d0d0d]",
      skipButton:
        "font-['WorkSansRegular'] text-[14px] leading-[120%] text-[#0d0d0d] cursor-pointer",
      modal: {
        container: "bg-[#f0f0f0] px-[40px] py-[48px]",
        title: "font-['UltraRegular'] text-[24px] leading-[120%] text-[#0d0d0d] text-center",
        text: "font-['WorkSansRegular'] text-[14px] leading-[120%] text-[#0d0d0d] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#0d0d0d] bg-white font-['WorkSansRegular'] text-[16px] leading-[120%] text-center",
        otpBorder: "#D4D4D4",
        otpBorderFocus: "#000000",
      },
    },
    global: {
      counterColor: "#ffffff",
      logo: {
        src: `${S3_PREFIX}web-logo.jpg`,
        styles: "w-[200px] h-[52px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[200px] h-[52px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#e7348e",
      asideBg: "#bdee3e",
      asideStyles: "border-r border-[#ffffff00]",
      contentBg: "#e7348e",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.png`,
      bgMobile: `${S3_PREFIX}web-background-mobile.png`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.mp4?type=video`,
      mainFont: "font-['WorkSansRegular']",
      primaryButton:
        "bg-[#ffffff] border border-[#ffffff] px-[18px] py-[18px] !text-[#0d0d0d] font-['TerminaTestDemi'] !text-[16px] uppercase text-left",
    },
    navigation: {
      iconsColor: "#0d0d0d",
      sideBarSeparator: "border-r-[1px] border-[#bdee3e]",
      separator: "#bdee3e",
      item: "text-[#0d0d0d] font-['WorkSansMedium'] text-[18px] uppercase text-left gap-x-[10px] text-opacity-50 text-center border-b border-[#bdee3e] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "bg-[#e7348e] border border-[#ffffff00] !pb-8 overflow-hidden",
      titles: "text-[#0d0d0d] font-['UltraRegular'] text-[24px] text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#0d0d0d] font-['WorkSansRegular'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0",
        sectionTitle:
          "text-[#0d0d0d] font-['UltraRegular'] text-[24px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] h-[326px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full h-[256px] bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#0d0d0d] font-['UltraRegular'] text-[24px] text-left leading-[110%]",
          subtitle:
            "text-[#0d0d0d] font-['WorkSansRegular'] text-[14px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0",
        sectionTitle:
          "text-[#0d0d0d] font-['UltraRegular'] text-[24px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title: "text-[#0d0d0d] font-['UltraRegular'] text-[14px] text-left leading-[110%]",
          subtitle:
            "text-[#0d0d0d] font-['WorkSansRegular'] text-[12px] text-left leading-[120%] mt-2",
          location: "text-[#0d0d0d] font-['WorkSansRegular'] text-[12px] text-left leading-[120%]",
          date: "text-[#0d0d0d] font-['WorkSansRegular'] text-[12px] text-left leading-[120%]",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#0d0d0d] font-['UltraRegular'] text-[20px] text-left leading-[110%]",
        text: "text-[#0d0d0d] font-['WorkSansRegular'] text-[18px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#0d0d0d] font-['UltraRegular'] text-[24px] text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#e7348e] border border-[#ffffff00] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title: "text-[#0d0d0d] font-['UltraRegular'] text-[24px] text-left leading-[110%]",
        subtitle:
          "text-[#0d0d0d] font-['WorkSansRegular'] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#ffffff] border border-[#ffffff] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#0d0d0d] font-['TerminaTestDemi'] text-[16px] uppercase text-left leading-[100%]",
        questions: "text-[14px] text-left leading-[120%]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#0d0d0d] font-['UltraRegular'] text-[20px] text-left leading-[110%]",
        text: "text-[#0d0d0d] font-['WorkSansRegular'] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#0d0d0d] font-['UltraRegular'] text-[20px] text-left leading-[110%]",
        text: "text-[#0d0d0d] font-['WorkSansRegular'] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#0d0d0d] font-['UltraRegular'] text-[20px] text-left leading-[110%]",
        text: "text-[#0d0d0d] font-['WorkSansRegular'] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#0d0d0d] font-['UltraRegular'] text-[24px] text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 pb-2 sm:pb-4",
        outerContainer: "flex flex-col !bg-[#e7348e] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto bg-[#ffffff00] border-b border-[#ffffff00] py-4 overflow-hidden",
          media: "!hidden",
          name: "text-[#0d0d0d] font-['UltraRegular'] text-[14px] text-left leading-[110%]",
          description:
            "text-[#0d0d0d] font-['WorkSansRegular'] text-[14px] text-left leading-[120%] !mt-1",
          price: "text-[#0d0d0d] font-['UltraRegular'] text-[14px] text-left leading-[110%] !mt-1",
          quantity: "text-[#ffffff] font-['TerminaTestDemi'] text-[14px] text-left",
          status: "text-[#0d0d0d] font-['UltraRegular'] text-[14px] text-left leading-[110%]",
          counterContainer:
            "bg-[#0d0d0d] border border-[#0d0d0d] !px-4 !py-3 gap-x-4 !w-fit !h-[43px]",
          button:
            "!bg-[#0d0d0d] border border-[#0d0d0d] px-4 py-3 text-[#ffffff] font-['TerminaTestDemi'] text-[14px] text-left !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
  },
}

export default sahraparty
